export interface IMemebersViewModel {
    member_Id?: number|null
    member_Name: string
    member_Short_Name: string
    group_Id: number
    reporting_To?: number|null
    staff_PSNo?: string
    ecc_Web_Login: string
    designation: string
    eMail_Id: string
    password?: string
    mobile_No: string
    is_Internal: boolean
    is_Active: boolean
    user_Id: number
    eIP_UserId?: number
    company_Code?: number
    lock_status?: boolean,
    address?: string,
    mobile_No_Prefix: string,
    group_Name: string|null
}

export interface IProjectMemberViewModel{
    member_Id?: number
    member_Name: string
    member_Short_Name: string
    group_Id: number
    reporting_To?: number
    staff_PSNo?: string
    ecc_Web_Login: string
    designation: string
    eMail_Id: string
    mobile_No: string
    is_Internal: boolean
    is_Active: boolean
    company_Code?: number
    address?: string,
    mobile_No_Prefix: string,
}

export interface IEipUserModel {
    referenceId: number,
    username: string
}

export interface IMemebersInputModel {
    member_Id?: number|null
    group_Id?: number
}

export interface IProjectMembersInputModel {
    group_Id?: number
    project_Id?: number
}

export interface IEipSessionValue {
    sessionCode: string,
    sessionValue: string
}
export interface IMemeberloginInputModel {
    suggestion: string
}
export interface IMemeberloginViewModel {
    login_Name: string,
    user_ID: number,
    password : string
}
